module.exports = "https://static.wmbcdn.com/uniweb/images/389a13cd0130be6eabbe8946e5ae6a43.svg";